import { Injectable, Inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { SharedService } from '../shared/shared.service';

export class AuthorizeInterceptor implements HttpInterceptor {
  private uri: string;

  constructor(private sharedService: SharedService) {
  }

  //Si la peticion se hace a la api especificada y
  //disponemos del token entonces lo insertamos en el header
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const idToken = localStorage.getItem("id_token");
    if (idToken && req.url.startsWith(this.sharedService.WebURL)) {
      const cloned = req.clone({
        headers: req.headers.set("Authorization",
          "Bearer " + idToken)
      });
      return next.handle(cloned);
    } else {
      return next.handle(req);
    }
  }


}
